import { format } from 'date-fns';
import { Field } from '@framework/ui/Organisms/FinalForm';
import DatePicker from '@creditflowresearch/uilib/Picker/DatePicker';
import { YEAR_MONTH_DAY_SLASH_FORMAT } from '@creditflowresearch/uilib/utils/dateFormats';
import { PORTFOLIO_OPTIONAL_DATA_FIELD_ARRAY } from './constants';

import styles from './styles.module.scss';

interface IProps {
  cellName: string,
  rowIndex: number,
}

const DatePurchasedCell = ({ cellName, rowIndex }: IProps) => {
  return (
    <Field
      name={ `${ PORTFOLIO_OPTIONAL_DATA_FIELD_ARRAY }[${ rowIndex }].${ cellName }` }
    >
      { ({ meta, input }) => (
        <DatePicker
          value={ input.value ? new Date(input.value) : null }
          onChange={ (value) => value && input.onChange(format(value, YEAR_MONTH_DAY_SLASH_FORMAT)) }
          meta={ meta }
          maxDate={ new Date() }
          dateFormat={ YEAR_MONTH_DAY_SLASH_FORMAT }
          placeholder="Select Date"
          name={ input.name }
          isClearable={ false }
          formFieldClassName={ styles.datePickerInput }
          dataTest="datepicker"
          inputDataTest={ cellName }
          isNarrow
        />
      ) }
    </Field>
  );
};

export default DatePurchasedCell;
